const numeral = require("numeral");
const currencyFormatter = require("currency-formatter");

function formatDecimal(s) {
  return numeral(s).format("0.00");
}
function formatNumber(s) {
  return numeral(s).format("0");
}

function formatCurrency(s) {
  return numeral(s).format("$0,0.00");
}

function formatRespectiveCurrency(value, currencyCode) {
  // return currencyFormatter.format(value, { code: currencyCode });
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currencyCode,
  }).format(value);
}

function formatShowMore(s) {
  return s > 0 ? numeral(s).format("0[.]0a+") : "0";
}

// Date-only strings ("YYYY-MM-DD") have no timezone, so parse them as local midnight.
// new Date("YYYY-MM-DD") reads them as UTC midnight, which lands on the previous day west of UTC.
// Datetime strings carry their own offset and convert to the viewer's timezone as usual.

function parseDate(value) {
  const match = typeof value === "string" && value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  return new Date(value);
}

module.exports = {
  parseDate,
  formatDecimal,
  formatNumber,
  formatCurrency,
  formatRespectiveCurrency,
  formatShowMore,
};
